<template>
    <section class="section" :style="{'background-color':bg}">
        <slot></slot>
    </section>
</template>
<script>
    export default {
        props:['bg']
    }
</script>
<style lang="less" scoped>
    .section{
        padding:30px;
    }
</style>
